import { render, staticRenderFns } from "./PhasesList.vue?vue&type=template&id=a61e1644&scoped=true&"
import script from "./PhasesList.vue?vue&type=script&lang=ts&"
export * from "./PhasesList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61e1644",
  null
  
)

export default component.exports